import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-8 md:py-12 px-3 bg-brand-dark border-y border-brand-accent/20" data-id="element-114">
      <div className="max-w-2xl mx-auto text-center" data-id="element-115">
        <div className="inline-flex items-center justify-center w-14 h-14 md:w-16 md:h-16 bg-brand-accent rounded-full mb-4 shadow-[0_0_20px_rgba(34,197,94,0.4)]" data-id="element-116">
          <ShieldCheck className="w-7 h-7 md:w-8 md:h-8 text-white" data-id="element-117" />
        </div>

        <h2 className="text-xl md:text-3xl font-black mb-4 text-brand-accent neon-glow" data-id="element-118">
          🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </h2>

        <div className="text-base md:text-lg font-bold space-y-2 mb-5 text-gray-200" data-id="element-119">
          <p data-id="element-120">Abrís los tomos. Los usás en el taller.</p>
          <p data-id="element-121">Si en 7 días no es lo que esperabas:</p>
          <div className="flex flex-col items-center justify-center gap-2 mt-3" data-id="element-122">
            <p className="text-lg md:text-xl font-black text-white bg-brand-card px-5 py-2 rounded-lg border border-brand-accent/50 w-full max-w-sm" data-id="element-123">
              👉 Devolución del 100%
            </p>
            <p className="text-lg md:text-xl font-black text-white bg-brand-card px-5 py-2 rounded-lg border border-brand-accent/50 w-full max-w-sm" data-id="element-124">
              👉 Sin formularios
            </p>
            <p className="text-lg md:text-xl font-black text-white bg-brand-card px-5 py-2 rounded-lg border border-brand-accent/50 w-full max-w-sm" data-id="element-125">
              👉 Sin vueltas
            </p>
          </div>
        </div>

        <p className="text-xs md:text-sm text-gray-400 font-bold bg-brand-card inline-block px-4 py-1.5 rounded-full border border-white/10 uppercase tracking-wider" data-id="element-126">
          Tasa de devoluciones: menos del 1%
        </p>
      </div>
    </section>;
}